import { IAccountingSystemInvoiceRepository, IGetAccountingSystemInvoicesRepositoryResponse } from "@/core/repositories/accounting";
  
  export class GetAccountingSystemInvoicesUseCase {
    constructor(private readonly accountingSystemInvoiceRepository: IAccountingSystemInvoiceRepository) {}
    
    async execute(
      refetch?: boolean
    ): Promise<IGetAccountingSystemInvoicesRepositoryResponse> {
      const response = await this.accountingSystemInvoiceRepository.getAccountingSystemInvoices(refetch);
  
      return response;
    }
  }